import { ImageUploadSettings } from "../constants";

export const DetailImageUpload: ImageUploadSettings = {
	maxFileSize: "20971520",
	extensions: ["jpeg", "jpg", "png"],
	dimensions: [{ width: 1080, height: 663 }, {width: 1044, height: 601}]
};

export type DetailTextLengthSettings = {
	detailText: number;
	applicantText: number;
	processText: number;
	durationText: number;
}

export const DetailTextLengthConstants: DetailTextLengthSettings = {
	detailText: 250,
	processText: 175,
	applicantText: 150,
	durationText: 150
};

export type DetailTextSettings = {
    header: {
		label: string,
		placeholder: string
    };
    detailText: {
		label: string,
		placeholder: string
	};
    applicantText: {
		label: string,
		placeholder: string
	};
    processText: {
		label: string,
		placeholder: string
	};
    durationText: {
		label: string,
		placeholder: string
	};
    customButtonText: {
		label: string,
		placeholder: string
	};
    customButtonUrl: {
		label: string,
		placeholder: string
	};
	image: {
		label: string,
	}
};

export const DetailTextConstants: Record<
    string,
    DetailTextSettings
> = {
	"tr-TR": {
		header: {
			label: "Başlık",
			placeholder: "Bakımevi Ziyareti ve Sahiplenme Etkinliği"
		},
		detailText: {
			label: "Program Detayı",
			placeholder: "Koç Gönüllüleri olarak, SemtPati Vakfı iş birliğiyle İBB Tepeören Sahipsiz Hayvan Bakımevi’ni ziyaret ediyor; ömürlük yuvalarını bekleyen patili dostlarımızla bir araya geliyoruz."
		},
		applicantText: {
			label: "Programa Kimler Başvurabilir?",
			placeholder: "Program kontenjanla sınırlıdır."
		},
		processText: {
			label: "Program Süreci",
			placeholder: "Köpeklerle bahçede ayrılan güvenli alanda vakit geçiriyor, oyun oynuyor; onların sosyalleşmesine ve insanlarla bağ kurmasına destek oluyoruz. Bakımevi sorumluları eşliğinde yaşam alanlarını ziyaret ederek süreç hakkında bilgi ediniyoruz. Sahiplenilmeyi bekleyen diğer dostlarımızla da tanışma fırsatı buluyoruz."
		},
		durationText: {
			label: "Başvurular Devam Ediyor",
			placeholder: "Başvurular devam ediyor! Başvur butonuna tıklayarak 15 Ekim 2026 tarihinde aramızda yerini al!"
		},
		customButtonText: {
			label: "Buton Metni",
			placeholder: "Bağış Yap"
		},
		customButtonUrl: {
			label: "Buton URL",
			placeholder: "https://www.example.com"
		},
		image: {
			label: "Proje Detay Görseli",
		}	
	},
	"en-US": {
		header: {
			label: "Title",
			placeholder: "Animal Shelter Visit and Adoption Event"
		},
		detailText: {
			label: "Program Detail",
			placeholder: "As Koç Volunteers, in collaboration with the SemtPati Foundation, we visit the IMM Tepeören Animal Shelter and meet our paw friends who are waiting for their forever homes."
		},
		applicantText: {
			label: "Who Can Apply to the Program?",
			placeholder: "The program has limited capacity."
		},
		processText: {
			label: "Program Process",
			placeholder: "We spend time with the dogs in a designated safe area, play games, and support their socialization and bonding with people. Accompanied by shelter staff, we visit their living areas and learn about the on-site process. We also have the opportunity to meet other friends waiting to be adopted."
		},
		durationText: {
			label: "Applications Are Ongoing",
			placeholder: "Applications are open! Click the Apply button and join us!"
		},
		customButtonText: {
			label: "Button Text",
			placeholder: "Donate"
		},
		customButtonUrl: {
			label: "Button URL",
			placeholder: "https://www.example.com"
		},
		image: {
			label: "Project Detail Image",
		}
	},
};
